<style src="./style.scss">

</style>

<div class="mbsc-col-12 class-grid">
  <div class="mbsc-form-box filter-form">
    <div class="mbsc-grid">
      <div class="mbsc-row mbsc-form-group">
        <div class="mbsc-col-sm-12 mbsc-col-lg-3">
          <div class="mbsc-row mbsc-form-grid">
            <div class="mbsc-col-12">
              <label>
                Disciplinas
                <select name="discipline" class="discipline-filter" multiple data-input-style="box" data-label-style="stacked">
                  {#if disciplineFilter}
                    {#each disciplineFilter as filter, index}
                    <option data-id={index} value={filter.slug}>{filter.title}</option>
                    {/each}
                  {/if}
                </select>
              </label>
            </div>
          </div>
        </div>
        <div class="mbsc-col-sm-12 mbsc-col-lg-3">
          <div class="mbsc-row mbsc-form-grid">
            <div class="mbsc-col-12">
              <label>
                Tipo
                <select name="class-type" class="class-type" multiple data-input-style="box" data-label-style="stacked">
                  {#if classType}
                    {#each classType as filter, index}
                    <option data-id={index} value={filter.slug}>{filter.title}</option>
                    {/each}
                  {/if}
                </select>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ul class="class-list mbsc-row">
  {#if sessions.length <= 0}
  <header class="mbsc-col-12 mbsc-col-lg-8">
    <h4>Aún no hay sesiones de esta disciplina.</h4>
    <p>Estamos por terminar estas sesiones, mientras tanto, ¿por qué no intentas con otras disciplinas?</p>
  </header>
  {:else}
  {#each sessions as session}
  <div class="mbsc-col-12 mbsc-col-md-6 mbsc-col-lg-4">
    <div class="mbsc-card class-card">
      <div class="mbsc-card-header">
        <img src="{session.details.profile_picture}" alt="session {session.id}" class="mbsc-avatar">
        <h5 class="mbsc-card-title mbsc-bold">{session.details.name}</h5>
        <div class="mbsc-card-subtitle {session.category.slug}">{session.details.disciplina}</div>
      </div>
      <img src="{session.poster}" alt="session {session.id}">
      <div class="mbsc-card-content">
        {session.videoInfo.about}
      </div>
      <div class="mbsc-card-footer mbsc-align-right">
        <button class="mbsc-btn mbsc-btn-flat" on:click={() => goTo(session)}>Ver</button>
      </div>
    </div>
  </div>
  {/each}
  {#if sessions.length < totalSessions.length}
  <div class="mbsc-padding mbsc-col-12 show-more-form">
    <button mbsc-button id="more" class="mbsc-btn-block mbsc-col-12 mbsc-col-4" on:click={loadMore}>Mostrar más clases</button>
  </div>
  {/if}
  {/if}
</ul>

<script>
  import { onMount, afterUpdate } from 'svelte';
  import { navigateTo } from 'yrv';

  import { Sessions, AWSAuth, Utils, ClassCategories } from '@Services';
  import { Cache } from 'aws-amplify';

  export let categoryFilter = null;

  const classPerPage = 6;
  const CATS_CACHE_KEY = 'd-ns-class-categories';

  let totalSessions = [];
  let sessions = [];
  let classList = null;
  let disciplineFilter = null;
  let classType = [
    {
      slug: 'all-types',
      title: 'Todas las clases',
    },
    {
      slug: 'free',
      title: 'Clases Gratis',
    },
    {
      slug: 'warm-up',
      title: 'Calentamiento',
    },
    {
      slug: 'skill',
      title: 'Skills',
    },
    {
      slug: 'movement',
      title: 'Movimientos',
    },
    {
      slug: 'combo',
      title: 'Combinaciones',
    },
    {
      slug: 'coreo',
      title: 'Coreografías',
    },
    {
      slug: 'training',
      title: 'Entrenamiento',
    },
    {
      slug: 're-hab',
      title: 'Rehabilitación',
    },
  ];
  let disciplineSelector = null;
  let classTypeSelector = null;
  let refreshingList = false;

  let loadMore = () => {
    if (sessions.length < totalSessions.length) {
      refreshingList = true;
      classList.showLoading();
      setTimeout(()=> {
        let nextItems = 9;
        if (Utils.isMobile()) {
          nextItems = 4;
        }
        sessions = totalSessions.slice(0, sessions.length + nextItems);
        classList.hideLoading();
        refreshingList = false;
      }, 750);
    }
  };

  let goTo = async (session) => {
    navigateTo('/session/' +  session.id);
  };

  let applyFilters = (disciplines) => {
    const classGridTop = document.querySelector('.class-grid').offsetTop;

    classList.showLoading();
    totalSessions = Sessions.getSessions(true);
    if ((disciplines.length <= 0) || (disciplines.includes('all-disciplines'))) {
      classList.hideLoading();
      disciplineSelector.clear();
      sessions = totalSessions.slice(0, classPerPage);
      window.scrollTo({
        top: classGridTop,
        left: 0,
        behavior: 'smooth'
      });
      return;
    }
    let filtered = [];
    try {
      totalSessions.forEach(element => {
        if (disciplines.includes(element.category.slug)) {
          filtered.push(element);
        }
      });
    } catch(e) {
      console.info(e);
    }
    totalSessions = filtered;

    sessions = totalSessions.slice(0, classPerPage);
    classList.hideLoading();
    window.scrollTo({
      top: classGridTop,
      left: 0,
      behavior: 'smooth'
    });
  };

  let applyTypes = (classTypes) => {
    const classGridTop = document.querySelector('.class-grid').offsetTop;
    classList.showLoading();
    totalSessions = Sessions.getSessions(true);
    if ((classTypes.length <= 0) || (classTypes.includes('all-types'))) {
      classList.hideLoading();
      classTypeSelector.clear();
      sessions = totalSessions.slice(0, 9);
      window.scrollTo({
        top: classGridTop,
        left: 0,
        behavior: 'smooth'
      });
      return;
    }
    let filtered = [];
    try {
      totalSessions.forEach(element => {
        for (let i = 0; i <= element.classType.slug.length; i++) {
          if (classTypes.includes(element.classType.slug[i])) {
            filtered.push(element);
            break;
          }
        }
      });
    } catch(e) {
      console.info(e);
    }
    totalSessions = filtered;

    sessions = totalSessions.slice(0, 9);
    classList.hideLoading();
    window.scrollTo({
      top: classGridTop,
      left: 0,
      behavior: 'smooth'
    });
  };

  afterUpdate(() => {
    mobiscroll.form('.filter-form', {
      theme: 'd-ns'
    });
    mobiscroll.card('.class-card', {
      theme: 'd-ns'
    });
    mobiscroll.form('.show-more-form', {
      theme: 'd-ns'        
    });
    disciplineSelector = mobiscroll.select('.discipline-filter', {
      theme: 'd-ns',
      touchUi: false,
      onSet: (event, instance) => {
        const disciplines = instance.getVal(true);
        applyFilters(disciplines);
      },
    });
    classTypeSelector = mobiscroll.select('.class-type', {
      theme: 'd-ns',
      touchUi: false,
      onSet: (event, instance) => {
        const classTypes = instance.getVal(true);
        applyTypes(classTypes);
      },
    });
    if (classList === null) {
      classList = mobiscroll.listview('.class-list', {
        enhance: true,
        swipe: false,
      });
    }
    disciplineFilter = Cache.getItem(CATS_CACHE_KEY);
    if (disciplineFilter === null) {
      ClassCategories.getAll()
      .then(categoryList => {
        disciplineFilter = categoryList;
        for (let i = 0; i < categoryList.length; i++) {
          if (disciplineFilter[i].slug === 'all-disciplines') {
            return;
          }
        }
        disciplineFilter.unshift({
          slug: 'all-disciplines',
          title: 'Ver Todas',
          description: '',
          color: '',
        });
        Cache.setItem(CATS_CACHE_KEY, disciplineFilter);
      });
    }
  });

  onMount(async () =>{
    AWSAuth.isAnonymous().then(response => {
      if (categoryFilter !== null) {
        applyFilters([categoryFilter]);
      }else{
        applyFilters([]);
      }
    });
  });
</script>
